import { EditOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import {
  cancelConsigmentOrderRefundModal,
  modalButtons,
  notDeleteableStatus,
  roleConst,
  UrlPaths,
} from '../../../../constants';
import { Dropdown, Menu } from 'antd';
import confirm from 'antd/lib/modal/confirm';
import { filterOptionsConst } from '../../../../constants/FilterOptions';
import { useNavigate } from 'react-router-dom';
import {
  consignmentOrderRefundTableOpt,
  filterConst,
} from '../../../../constants/ConsignOrderRefund.const';

export const ConsignOrderRefundTableOptions = ({
  id = null,
  action = {},
  status = '',
  privileges = [],
  role = null,
  numberOrder,
  consignmentOrderId,
}) => {
  const navigate = useNavigate();
  const { onDelete } = !!action && action;
  const isPaid = status === filterOptionsConst.APPROVE;

  let options = consignmentOrderRefundTableOpt()
    .filter((opt) => privileges.includes(opt.privilege))
    .filter((opt) => {
      if (isPaid) {
        return opt.key === filterConst.EDIT;
      }
      return opt.key !== filterConst.PDF;
    });

  if (roleConst.branchManager === role) {
    options.push({
      label: 'Editar',
      key: 'edit',
      icon: <EditOutlined />,
      privilege: 'edit',
    });
  }

  if (notDeleteableStatus.includes(status)) {
    options = options.filter((opt) => opt.key !== filterOptionsConst.DELETE);
  }

  const renderMenu = (id) => {
    return (
      <Menu
        onClick={({ key }) => handleMenuClick(key, id, numberOrder)}
        items={options}
      />
    );
  };

  const handleMenuClick = (key, id, numberOrder) => {
    switch (key) {
      case 'edit':
        navigate(
          UrlPaths.CONSIGNMENT_ORDER_REFUND_EDIT(
            consignmentOrderId,
            numberOrder,
            id
          )
        );
        break;
      case 'cancel':
        showDeleteConfirm();
        break;
      default:
        break;
    }
  };

  const showDeleteConfirm = () => {
    confirm({
      title: cancelConsigmentOrderRefundModal.title,
      icon: <ExclamationCircleOutlined />,
      content: cancelConsigmentOrderRefundModal.body,
      okType: 'danger',
      okText: modalButtons.confirm,
      cancelText: modalButtons.cancel,
      onOk() {
        return new Promise((resolve) => {
          setTimeout(resolve(onDelete.action(...onDelete.params)), 1000);
        });
      },
      onCancel() {},
    });
  };

  return (
    <Dropdown.Button
      disabled={!(options.length > 0)}
      overlay={renderMenu(id)}
      trigger={['click']}
      placement="bottom"
    />
  );
};
